import React from "react";
import { debug } from "../../utils";
import { connect } from "react-redux";
import { CheckboxTable } from "../../view/CheckboxTable";
import { useParameterTableHelper } from "./useParameterTableHelper";
import ParametersTableRow from "./ParametersTableRow";

function ParametersTable({ parameters = [] }) {

    const helper = useParameterTableHelper();

    const headers = [
        { name: 'NAME', sortKey: 'name', onClick: () => helper.onNameClick() },
        { name: 'VALUE', sortKey: 'value', onClick: () => helper.onValueClick() },
    ]

    return (
        <>
            {parameters.length > 0 ?
                <CheckboxTable headers={headers} elements={parameters}>
                    {parameters.map((data, index) => <ParametersTableRow key={index} data={data} totalRows={parameters.length}
                        index={index} />)}
                </CheckboxTable>
                :
                <div className="oct_empty-state-v2">
                    <div className="oct_empty-state-title">No parameters found</div>
                    <div>Add a parameter to start reusing values across your rules.</div>
                </div>
            }
        </>
    );

}


function mapStateToProps(state) {
    debug("parametersTable mapStateToProps", state);
    const parametersPage = state.parametersPage;
    return {
        parameters: parametersPage.parameters || []
    };
}

export default connect(mapStateToProps)(ParametersTable)
